import { render, staticRenderFns } from "./Scoring3.vue?vue&type=template&id=0f87fbbc&"
import script from "./Scoring3.vue?vue&type=script&lang=js&"
export * from "./Scoring3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports